import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS } from "../data/site";

export default function FAQSection({ items = FAQS, title, eyebrow, headingTag: Tag = "h2" }) {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section-pad border-t border-black/10 bg-[#fbfaf7]"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="overline">{eyebrow || "FAQ Hub"}</div>
          <Tag className="font-serif-display mt-4 text-4xl sm:text-5xl lg:text-[52px] tracking-tight leading-[1.05]">
            {title || "Gastroenterology FAQs — Varanasi."}
          </Tag>
          <p className="mt-6 text-black/65 max-w-sm text-[15px] leading-relaxed">
            Written by Dr. Dixit. Updated as guidelines change. If your question
            is missing, message us on WhatsApp.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-black/15"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left py-5 hover:no-underline group"
                >
                  <span className="flex items-start gap-5">
                    <span className="text-[12px] tracking-[0.18em] uppercase text-[#0370AD] font-semibold pt-1.5 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display-semibold text-lg md:text-xl leading-snug">
                      {f.q}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pl-[58px] pb-6 text-[15px] text-black/75 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
